import React from "react";
import styled from "styled-components/macro";
import ErrorIcon from "ui/Icons/Error";
import Typography from "ui/Typography";

type FormErrorProps = {
  children: React.ReactNode;
  /**
   * An id used for accessibility, that can be referred to by a form control, ex. `aria-describedby="schoolLeaderEmailError"`.
   */
  id: string;
  /**
   * Determines if the FormError will be shown or not.
   */
  isInvalid: boolean;
  for?: string;
};

const $Container = styled.div`
  margin-top: ${({ theme }) => theme.SizeXs};
  line-height: ${({ theme }) => theme.FontSizeTooltip};
`;

// icon is smaller than usual to sit inline with the small text
const $IconContainer = styled.div`
  display: inline;
  margin-right: ${({ theme }) => theme.Size2xs};

  svg {
    width: 0.875rem;
    height: 0.875rem;
  }
`;

const $FormError = styled(Typography).attrs({
  size: "tooltip",
})<{ $isInvalid: boolean }>`
  display: ${({ $isInvalid }) => ($isInvalid ? "inline" : "none")};
  padding-top: ${({ theme }) => theme.Size2xs};
  color: ${({ theme }) => theme.ColorEraserRed300};
`;

/**
 * Displays an input error with the given text (as children).
 */
export default function FormError({ isInvalid, ...props }: FormErrorProps) {
  return (
    <$Container>
      {isInvalid && (
        <$IconContainer>
          <ErrorIcon color="ColorEraserRed200" role="presentation" />
        </$IconContainer>
      )}
      <$FormError aria-live="polite" $isInvalid={isInvalid} {...props} />
    </$Container>
  );
}
